import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useUser } from "../Context/UserContext";
import { useCompany } from "../Context/CompanyContext";
import API_URL from "../config";

const SolicitarCotizacionModal = ({ show, onClose, plan }) => {
  const { user } = useUser();
  const { companies } = useCompany();

  const [form, setForm] = useState({
    empresa: "",
    contacto_nombre: "",
    contacto_email: "",
    contacto_telefono: "",
    mensaje: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;
    setForm({
      empresa: companies?.company?.nombre_empresa || "",
      contacto_nombre: user ? `${user.user.nombre} ${user.user.apellido}` : "",
      contacto_email: user?.user?.correo || "",
      contacto_telefono: "",
      mensaje: "",
    });
    setError("");
  }, [show, user, companies]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API_URL}/leads/quote-request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, plan_interes: plan }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.error || "Error en la solicitud. Inténtalo más tarde.");
        return;
      }

      toast.success("Solicitud enviada, te contactaremos pronto");
      onClose();
    } catch (err) {
      console.error("Error al enviar la solicitud de cotización:", err);
      setError("Error en la conexión con el servidor. Inténtalo más tarde.");
    } finally {
      setLoading(false);
    }
  };

  const ctaLabel = plan === "Enterprise" ? "Hablar con ventas" : "Solicitar cotización";

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{ctaLabel} — Plan {plan}</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label htmlFor="empresa" className="mb-1.5 block text-sm font-medium text-foreground">
              Empresa
            </label>
            <Input
              id="empresa"
              name="empresa"
              value={form.empresa}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label htmlFor="contacto_nombre" className="mb-1.5 block text-sm font-medium text-foreground">
              Nombre de contacto
            </label>
            <Input
              id="contacto_nombre"
              name="contacto_nombre"
              value={form.contacto_nombre}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label htmlFor="contacto_email" className="mb-1.5 block text-sm font-medium text-foreground">
              Correo de contacto
            </label>
            <Input
              id="contacto_email"
              name="contacto_email"
              type="email"
              value={form.contacto_email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label htmlFor="contacto_telefono" className="mb-1.5 block text-sm font-medium text-foreground">
              Teléfono (opcional)
            </label>
            <Input
              id="contacto_telefono"
              name="contacto_telefono"
              value={form.contacto_telefono}
              onChange={handleChange}
            />
          </div>

          <div>
            <label htmlFor="mensaje" className="mb-1.5 block text-sm font-medium text-foreground">
              Mensaje (opcional)
            </label>
            <textarea
              id="mensaje"
              name="mensaje"
              value={form.mensaje}
              onChange={handleChange}
              rows={3}
              className="flex w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50"
            />
          </div>

          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "Enviando..." : ctaLabel}
          </Button>
          {error && <p className="text-center text-sm font-semibold text-destructive">{error}</p>}
        </form>

        <p className="text-center text-xs text-muted-foreground">
          O contáctanos directamente:{" "}
          <a href="mailto:procuperu1@gmail.com" className="font-medium hover:underline">
            procuperu1@gmail.com
          </a>{" "}
          /{" "}
          <a href="tel:+51939560222" className="font-medium hover:underline">
            939 560 222
          </a>
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default SolicitarCotizacionModal;
